import { Card, CardContent, Stack, Typography } from '@mui/material'
import TrendingUpRounded from '@mui/icons-material/TrendingUpRounded'
import TrendingDownRounded from '@mui/icons-material/TrendingDownRounded'
import type { ReactNode } from 'react'

interface Props {
  label: string
  value: ReactNode
  hint?: string
  tone?: 'default' | 'positive' | 'negative'
  center?: boolean
}

export default function StatCard({ label, value, hint, tone = 'default', center = false }: Props) {
  const color =
    tone === 'positive' ? 'success.main' : tone === 'negative' ? 'error.main' : 'text.primary'
  const TrendIcon =
    tone === 'positive' ? TrendingUpRounded : tone === 'negative' ? TrendingDownRounded : null
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ textAlign: center ? 'center' : 'left' }}>
        <Typography variant="overline" sx={{ color: 'text.secondary' }}>
          {label}
        </Typography>
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            mt: center ? 1 : 0.5,
            alignItems: 'center',
            justifyContent: center ? 'center' : 'flex-start',
          }}
        >
          {TrendIcon && <TrendIcon sx={{ color, fontSize: center ? 26 : 20 }} />}
          <Typography variant={center ? 'h4' : 'h5'} sx={{ color, lineHeight: 1.2 }}>
            {value}
          </Typography>
        </Stack>
        {hint && (
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
            {hint}
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}
